export default __webpack_public_path__ + "static/media/logo_icon_dark.cdcf0d1a.png";